// extracted by mini-css-extract-plugin
module.exports = {"container":"AccountMenu_container__t8yH9","screen":"AccountMenu_screen__TglUW"};